import e from "@dialpad/dialtone-tokens/layered/themes/tokens-132-colors.css?inline";
//#region themes/132.js
var t = { brand: {
	css: e,
	name: "132"
} };
//#endregion
export { t as default };
